export const landingPageData = {
    "default": {
        "consentText": "By booking this appointment, you are sharing your details and giving Money Wellness consent to contact you. If you want to find out how Money Wellness process personal data, visit",
        "privacyPolicyLink": "https://www.moneywellness.com/privacy-policy",
        "privacyPolicyLinkText": "MoneyWellness.com/Privacy-Policy",
        "notesFieldEnabled": false
    },
    "moneyadvisorycentre.com": {
        "consentText": "By booking this appointment, you are sharing your details and giving Money Advisory Centre consent to contact you. If you want to find out how Money Advisory Centre process personal data, visit",
        "privacyPolicyLink": "https://www.moneyadvisorycentre.com/privacy-policy",
        "privacyPolicyLinkText": "MoneyAdvisoryCentre.com/Privacy-Policy",
        "notesFieldEnabled": false
    },
    "booking-nb-macadvice.moneyadvisorycentre.com": {
        "consentText": "By booking this appointment, you are sharing your details and giving Money Advisory Centre consent to contact you. If you want to find out how Money Advisory Centre process personal data, visit",
        "privacyPolicyLink": "https://www.moneyadvisorycentre.com/privacy-policy",
        "privacyPolicyLinkText": "MoneyAdvisoryCentre.com/Privacy-Policy",
        "notesFieldEnabled": true,
    },
    "localhost": {
        "consentText": "By booking this appointment, you are sharing your details and giving Money Wellness consent to contact you. If you want to find out how Money Wellness process personal data, visit",
        "privacyPolicyLink": "https://www.moneywellness.com/privacy-policy",
        "privacyPolicyLinkText": "MoneyWellness.com/Privacy-Policy",
        "notesFieldEnabled": true
    }
};

export const landingPageData_qa = {
    "default": {
        "privacyPolicyLink": "https://www.qaext.moneywellness.com/privacy-policy",
    },
    "moneyadvisorycentre.com": {
        "privacyPolicyLink": "https://www.qa.moneyadvisorycentre.com/privacy-policy",
    },
    "booking-nb-macadvice.qa.moneyadvisorycentre.com": {
        "consentText": "By booking this appointment, you are sharing your details and giving Money Advisory Centre consent to contact you. If you want to find out how Money Advisory Centre process personal data, visit",
        "privacyPolicyLink": "https://www.qa.moneyadvisorycentre.com/privacy-policy",
        "privacyPolicyLinkText": "MoneyAdvisoryCentre.com/Privacy-Policy",
        "notesFieldEnabled": true,
    },
}

export const landingPageData_development = {
    "default": {
        "privacyPolicyLink": "https://www.development.moneywellness.com/privacy-policy",
    },
    "moneyadvisorycentre.com": {
        "privacyPolicyLink": "https://www.development.moneyadvisorycentre.com/privacy-policy",
    },
}

export default landingPageData;